export const styleByScreenSize = width => {
  const allMarginsAndButtonSizes = 120
  return {
    maxWidth: width > 0 ? `${width - allMarginsAndButtonSizes}px` : '380px',
    boxShadow:
      width > 0
        ? '0px 0px 13px rgba(51, 51, 51, 0.1)'
        : '0px 0px 30px rgba(51, 51, 51, 0.1)',
    margin: width > 0 ? '10px 0 10px 10px' : '16px 0 16px 16px',
  }
}
